module.exports = __webpack_public_path__ + "2ed62611102bb6142aecc207a098a339.svg";